var s = Object.defineProperty, f = Object.defineProperties;
var p = Object.getOwnPropertyDescriptors;
var r = Object.getOwnPropertySymbols;
var c = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
var m = (e, t, o) => t in e ? s(e, t, { enumerable: !0, configurable: !0, writable: !0, value: o }) : e[t] = o, i = (e, t) => {
  for (var o in t || (t = {}))
    c.call(t, o) && m(e, o, t[o]);
  if (r)
    for (var o of r(t))
      n.call(t, o) && m(e, o, t[o]);
  return e;
}, a = (e, t) => f(e, p(t));
import d, { forwardRef as l } from "react";
import w from "../lib/IconBase.mjs";
import L from "../defs/List.mjs";
const R = l((e, t) => /* @__PURE__ */ d.createElement(w, a(i({ ref: t }, e), { weights: L })));
R.displayName = "List";
export {
  R as List
};
